export function getUrl(cloudName, resourceType, publicId) {
  return `https://res.cloudinary.com/${cloudName}/${resourceType}/upload/${publicId}`
}

export function getSimpleTransformationUrl(cloudName, resourceType, publicId, width) {
  return `https://res.cloudinary.com/${cloudName}/${resourceType}/upload/w_${width}/${publicId}.png`
}

export function getTransformationUrl(
  cloudName,
  resourceType,
  publicId,
  width,
  height,
  format
) {
  return `https://res.cloudinary.com/${cloudName}/${resourceType}/upload/w_${width},h_${height},c_fill/${publicId}.${format}`
}

function getAttachmentFilename(filename) {
  return filename
    .replace(/[^A-Za-z0-9_! -]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}

export function getDownloadUrl(cloudName, resourceType, publicId, format, filename) {
  const attachmentFilename = filename ? getAttachmentFilename(filename) : ''
  const attachment = attachmentFilename
    ? `fl_attachment:${encodeURIComponent(attachmentFilename)}`
    : 'fl_attachment'
  return `https://res.cloudinary.com/${cloudName}/${resourceType}/upload/${attachment}/${publicId}.${format}`
}
